// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Tezza-9342.JPG", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  height: 90vh; /* only this area shows the fixed image */
  display: flex; /* centers content vertically */
  align-items: center; /* vertical centering */
  justify-content: center; /* horizontal centering */
  color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  position: relative;
  padding: 0 20px;
}

/* Content inside header */
.header-content {
  position: relative;
  z-index: 2;
}

 /* Fallback for failed mobile header image fixed position */
@media (max-width: 768px) {
  .header {
    background-attachment: initial;
  }
}

.header-content h1 {
  font-size: clamp(3rem, 4vw, 3.5rem);
  margin-bottom: 20px;
  color: white;
  -webkit-text-stroke: 2px black; /* outline thickness + color */
  font-weight: 700;
}

.header-content h2 {
  color: white;
  -webkit-text-stroke: 1px pink; /* outline thickness + color */
  font-weight: 300;
}

.header-button {
  background: #000;
  color: #fff;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  transition: 0.3s;
}

.header-button:hover {
  background: #444;
}`, "",{"version":3,"sources":["webpack://./src/Sections/Header/Header.css"],"names":[],"mappings":"AAAA;EACE,YAAY,EAAE,yCAAyC;EACvD,aAAa,EAAE,+BAA+B;EAC9C,mBAAmB,EAAE,uBAAuB;EAC5C,uBAAuB,EAAE,yBAAyB;EAClD,YAAY;EACZ,yDAAoD;EACpD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;AACZ;;CAEC,2DAA2D;AAC5D;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,8BAA8B,EAAE,8BAA8B;EAC9D,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,6BAA6B,EAAE,8BAA8B;EAC7D,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".header {\n  height: 90vh; /* only this area shows the fixed image */\n  display: flex; /* centers content vertically */\n  align-items: center; /* vertical centering */\n  justify-content: center; /* horizontal centering */\n  color: white;\n  background-image: url(\"../../assets/Tezza-9342.JPG\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  position: relative;\n  padding: 0 20px;\n}\n\n/* Content inside header */\n.header-content {\n  position: relative;\n  z-index: 2;\n}\n\n /* Fallback for failed mobile header image fixed position */\n@media (max-width: 768px) {\n  .header {\n    background-attachment: initial;\n  }\n}\n\n.header-content h1 {\n  font-size: clamp(3rem, 4vw, 3.5rem);\n  margin-bottom: 20px;\n  color: white;\n  -webkit-text-stroke: 2px black; /* outline thickness + color */\n  font-weight: 700;\n}\n\n.header-content h2 {\n  color: white;\n  -webkit-text-stroke: 1px pink; /* outline thickness + color */\n  font-weight: 300;\n}\n\n.header-button {\n  background: #000;\n  color: #fff;\n  padding: 12px 24px;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: 0.3s;\n}\n\n.header-button:hover {\n  background: #444;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
